import { roleOptions } from "../../consts/dropDownOptions/registrationOptions";

export function formatLinkedUserDisplay(linkedUser) {
  if (linkedUser == null) return "";
  const fullName = [linkedUser.first_name, linkedUser.last_name].filter(Boolean).join(" ").trim();
  if (fullName) return fullName;
  if (typeof linkedUser.username === "string" && linkedUser.username.trim()) {
    return linkedUser.username.trim();
  }
  if (typeof linkedUser.email === "string" && linkedUser.email.trim()) {
    return linkedUser.email.trim();
  }
  return linkedUser.id != null ? `User #${linkedUser.id}` : "";
}

export function formatLinkedUserRole(role) {
  if (role == null || String(role).trim() === "") return "";
  const match = roleOptions.find((option) => option.value === role);
  return match?.name ?? String(role).replace(/_/g, " ");
}

/** Normalizes linked_user for contact table rows (admin columns). */
export function mapContactLinkedUserFields(contact) {
  const linkedUser = contact?.linked_user;
  return {
    linked_user_name: formatLinkedUserDisplay(linkedUser),
    linked_user_email:
      linkedUser?.email != null && String(linkedUser.email).trim() !== ""
        ? String(linkedUser.email).trim()
        : "",
    linked_user_username:
      linkedUser?.username != null && String(linkedUser.username).trim() !== ""
        ? String(linkedUser.username).trim()
        : "",
    linked_user_role: formatLinkedUserRole(linkedUser?.role),
  };
}

export function formatLinkedContactDisplay(contact) {
  if (contact == null) return "";
  const fullName = [contact.first_name, contact.last_name].filter(Boolean).join(" ").trim();
  if (fullName) return fullName;
  if (typeof contact.email === "string" && contact.email.trim()) {
    return contact.email.trim();
  }
  return contact.id != null ? `Contact #${contact.id}` : "";
}

export function isContactAvailableForLink(contact) {
  return contact?.linked_user == null;
}
